var $ = (global.jQuery = require('jquery'));
var _ = require('underscore');
var Marionette = require('backbone.marionette');
require('select2');
require('select2Plugins');

/*
    OPTIONS:
        select2Options: {
            selectableOptgroups: boolean, use this plugin if true https://github.com/bnjmnhndrsn/select2-optgroup-select
        }
*/

var Select2 = Marionette.ItemView.extend({
    select2Options: {},
    template: false,
    initialize: function() {
        var select2Options = this.getOption('select2Options');
        if (select2Options.ajax) {
            this.on('deserialize', this.fetchInitialValue);
        }
    },
    onRender: function() {
        this.selectEl = this.getOption('selectEl') || this.$('select:first, input:first');
        var select2Options = this.getOption('select2Options');

        var dropdownParent = $('<div>').addClass('select2-dropdown-container');

        if (select2Options.selectableOptgroups) {
            _.extend(select2Options, {
                dataAdapter: $.fn.select2.amd.require('optgroup-data'),
                resultsAdapter: $.fn.select2.amd.require('optgroup-results'),
                dropdownParent: dropdownParent,
            });
        }

        this.selectEl.parent().append(dropdownParent);

        this.selectEl.select2(_.extend({ width: '100%' }, select2Options));
    },
    fetchInitialValue: function(value) {
        if (!value) {
            return;
        }
        var select2Options = this.getOption('select2Options');
        var options = _.pick(select2Options.ajax, 'url', 'dataType');

        _.extend(options, {
            // manually convert the value to ensure shallow serialization
            data: $.param({ id: value }, true),
        });

        $.ajax(options).done(
            _.bind(function(data) {
                // value has already been set by something else
                if (this.selectEl.val()) {
                    return;
                }

                var results = select2Options.ajax.processResults(data);
                var data = results.results;

                // initial value not found or user doesnt have permission to search by it
                if (!data || !data.length) {
                    return;
                }

                var html = _.reduce(
                    data,
                    function(acc, datum) {
                        return acc + '<option value="' + datum.id + '">' + datum.name + '</option>';
                    },
                    ''
                );

                var ids = this.selectEl.prop('multiple') ? _.pluck(data, 'id') : data[0].id;
                this.selectEl
                    .append(html)
                    .val(ids)
                    .change();
            }, this)
        );
    },
});

module.exports = Select2;
